export const newDocNamesByExt = {
    docx: 'Новый документ',
    xlsx: 'Новая таблица',
    pptx: 'Новая презентация',
};
